//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "marionette",
  "messaging/messenger",
  "./departmentHistoryModalView",
  "modules/shared/sortableList/sortableListModule",
], function (Marionette, Messenger, DepartmentHistoryModalView, SortableListModule) {
  "use strict";

  var DepartmentHistoryModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "departmentHistoryModal";
    },
    show: function (department) {
      this.layout = new DepartmentHistoryModalView.departmentHistoryModalLayout({
        model: department,
      });
      var headers = Messenger.reqres.request("department:history:headers");
      this.departmentHistoryList = this.addSubModule(
        new SortableListModule({
          region: this.layout.departmentHistory,
          headers: headers,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          namespace: "departmentHistory",
        }),
      );

      this.layout.on(
        "done",
        function () {
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      this.layout.on(
        "show",
        function () {
          this._showSubViews(department);
        },
        this,
      );

      this.showRegion(this.layout);

      this.department = department;
    },
    _showSubViews: function (department) {
      this.departmentHistoryList.show(department.history());
    },
  });

  return DepartmentHistoryModalController;
});
